import { generateRandomPassword } from "../common/commonFunctions";
import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllTeams = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 99999,
  customer = [],
  superior = [],
  team = [],
  location = [],
  sort = [],
  userRole,
  currentUserId,userId
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    customers: {
      id: {
        $in: customer,
      },
    },
    locations: {
      id: {
        $in: location,
      },
    },

    superior: {
      id: {
        $in: superior,
      },
    },
    id: {
      $in: team,
    },
  };

  if (location?.length == 0 && userRole !== "super_admin") {
    assetFilters.locations = {
      id: {
        $in: currentUserId,
      },
    };
  } else {
    assetFilters.locations = {
      id: {
        $in: location,
      },
    };
  }

  if(userRole === "requester"){
    assetFilters.createdByUser = {
      id: {
        $in: userId,
      },
    };
  }
  
  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "superior",
      "images",
      "superior.profileImage",
      "users",
      "users.profileImage",
      "createdByUser",
      "updatedByUser",
      "createdByUser.profileImage",
      "customers",
      "customers.logo",

      "locations",
      "locations.customer.logo",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `teams?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;
    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };
    return dataObj;
  } catch (err) {
   
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const updateTeam = async (
  id,
  name,
  description,
  users,
  superior,
  locations,
  organisation,
  customers,
  images
) => {
  try {
    let params = {
      name,
      description,
      users,
      superior,
      locations,
      organisation,
      customers,
      images,
    };
    const response = await uninterceptedAxiosInstance.put(
      backend_url + "teams/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
   
    return the_response;
  } catch (err) {
    
    if (err.response) {
      
    } else if (err.request) {
      
    } else {
      
    }
   
    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const deleteTeam = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "teams/removeTeams",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const createNewTeam = async (
  name,
  description,
  users,
  superior,
  locations,
  organisation = "",
  createdByUser = null,
  customer = null,
  images
) => {
  try {
    const password = generateRandomPassword(6);

    let params = {
      name,
      description,
      users,
      superior,
      locations,
      organisation,
      createdByUser,
      customers: customer,
      images,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "teams",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const getAllTeamsByLocation = async (
  customerID,
  organisationID = ""
) => {
  const baseFilter = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
  };

  let filters;
  if (customerID?.length === 1) {
    filters = {
      $and: [
        baseFilter,
        {
          locations: {
            id: {
              $in: [customerID],
            },
          },
        },
      ],
    };
  } else {
    filters = {
      ...baseFilter,
      locations: {
        id: {
          $in: customerID,
        },
      },
    };
  }
  const query = qs.stringify(
    {
      sort: ["countNumId:desc"],
      filters,
    
      populate: [
        "userProfile",
        "role",
        "locations",
        "teams",
        "supervisor",
        "supervisor.profileImage",
        "createdByUser",
        "createdByUser.profileImage",
        "profileImage",
      ],
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `teams?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
